import type { LegalSection } from './legalMeta';
import { LEGAL_META } from './legalMeta';

export const cookiePolicyTitle = 'Cookie Policy';

export const cookiePolicySections: LegalSection[] = [
  {
    id: 'what',
    title: 'What Are Cookies and Similar Technologies',
    paragraphs: [
      'Cookies and similar technologies are small files or identifiers stored on your device or browser. We use them on our website as described below. The ' +
        LEGAL_META.brandName +
        ' mobile App does not use advertising cookies.',
    ],
  },
  {
    id: 'website',
    title: 'Website (Waitlist)',
    paragraphs: [
      'On ' + LEGAL_META.siteName + ' we may use:',
    ],
    listItems: [
      'Strictly necessary storage: for example, remembering your cookie consent choice.',
      'Google reCAPTCHA: to protect our waitlist from abuse. reCAPTCHA may set cookies or use similar technologies and process data according to Google’s policies.',
    ],
  },
  {
    id: 'choices',
    title: 'Your Choices',
    paragraphs: [
      'When you first visit our website, you can accept or reject non-essential cookies such as reCAPTCHA-related technologies.',
      'You can change browser settings to block cookies; some site features may not work.',
    ],
  },
  {
    id: 'contact-cookies',
    title: 'Contact',
    paragraphs: [`Questions: ${LEGAL_META.contactEmail}. See also our Privacy Policy.`],
  },
];
